module.exports = __webpack_public_path__ + "img/ask-helper.a0960872.png";